import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {RoomOptionsComponent} from './Pages/Options-admin/room-options/room-options.component';
import {EquipementsComponent} from './Pages/Options-admin/equipements/equipements.component';
import {AuthGuard} from './Guards/auth.guard';
import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { ReportingComponent } from './Pages/House-maid-reporting/reporting/reporting.component';
import { FastCheckInComponent } from './Pages/Front-desk/fast-check-in/fast-check-in.component';

const routes: Routes = [
  {
    path: '',
    component: BaseLayoutComponent,
    children: [
      // Nothing to structure for the main module
      {
        path: '',
        redirectTo: '/main/dashboardAdmin',
        pathMatch: 'full'
      },
      {
        path: 'main', 
        loadChildren: () => import('app/Pages/Main/lazy-main.module').then(m => m.MainlazyModule),
        data: {extraParameter: ''},canActivate: [AuthGuard]
      },
      // Nothing to structure for the front desk module
    
      {
        path: 'front-desk',
        loadChildren: () => import('app/Pages/Front-desk/lazy-front-desk.module').then(m => m.LazyFrontDeskModule),
        data: {extraParameter: ''},
        canActivate: [AuthGuard]
      },
      // Nothing to structure for the house keeping module
      {
        path : 'house-keeping',
        loadChildren :()=>import('app/Pages/House-keeping/lazy-house-keeping.module').then(m => m.HouseKeepingLazyModule),
        data: {extraParameter: ''},
        canActivate: [AuthGuard]
      },
      {
        path : 'back-office',
        loadChildren :()=>import('app/Pages/Back-Office/back-office-router.module').then(m => m.BackOfficeRouterModule),
        data: {extraParameter: ''},
        canActivate: [AuthGuard]
      },
      {
        path:'room-options',
        loadChildren : ()=>import('app/Pages/Options-admin/lazy-room-options.module').then(m=>m.LazyRoomOptionsModule),
        data: {extraParameter: ''},
        canActivate: [AuthGuard]

      },
      //{path: 'equipements', component: EquipementsComponent,canActivate: [AuthGuard]},
      { 
        path: 'admin', 
        loadChildren: () => import('./Pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard]
      },
      { 
        path: 'reports', 
        loadChildren: () => import('./Pages/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'accounting',
        loadChildren: () => import('./Pages/accounting/accounting.module').then(m => m.AccountingModule),
        canActivate: [AuthGuard]
      },
      { 
        path: 'rate-management', 
        loadChildren: () => import('./Pages/rate-management/rate-management.module').then(m => m.RateManagementModule),
        canActivate: [AuthGuard]
      }
    ]   
    },
    {
      path:'housemaid/reporting/:id/:name',
      component:ReportingComponent,
      //for the moment
      //canActivate:[AuthGuard]
    },
    {
      path: 'pre-checkin/:id',
      component: FastCheckInComponent,
      data: { preload: true },
      // No canActivate - publicly accessible
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
